module.exports = __webpack_public_path__ + "img/404.639ca5c8.svg";